import { concatMap } from "rxjs";
import generateSecureToken from "../../../utils/generateSecureToken";
import { apiService } from "../../ApiService";

export type StripeFormData = {
  paymentMethod?: unknown;
  plan: string;
  coupon?: string;
};

export const stripeSubscribe = (subscribe: StripeFormData) => {
  return generateSecureToken(apiService.userAgent).pipe(
    concatMap((secureToken) => {
      return apiService.post<{ secret?: string }>({
        path: `v1/store/blacknut/subscribe`,
        body: subscribe,
        secureToken,
      });
    }),
  );
};
